import React from "react";
import IntroScreen from "../../screens/IntroScreen/IntroScreen";
import SceneOneScreen from "../../screens/SceneOneScreen";
import SceneTwoScreen from "../../screens/SceneTwoScreen";
import SceneThreeScreen from "../../screens/SceneThreeScreen";
import SceneFourScreen from "../../screens/SceneFourScreen";
import SceneFiveScreen from "../../screens/SceneFiveScreen";
import SceneSixScreen from "../../screens/SceneSixScreen";
import Flow from "../flow/flow";

export default function App() {
  localStorage.clear();
  return <Flow />;

  const [screen, setScreen] = React.useState("");

  const callback = (screenVal) => {
    setScreen(screenVal);
  };
  switch (screen) {
    case "scene-one":
      return <SceneOneScreen parentCallback={callback} />;
    case "scene-two":
      return <SceneTwoScreen parentCallback={callback} />;
    case "scene-three":
      return <SceneThreeScreen parentCallback={callback} />;
    case "scene-four":
      return <SceneFourScreen parentCallback={callback} />;
    case "scene-five":
      return <SceneFiveScreen parentCallback={callback} />;
    case "scene-six":
      return <SceneSixScreen />;

    default:
      return <IntroScreen parentCallback={callback} />;
  }
}
